<div class="payin-deposit-details">
  <p class="p-text-secondary mb-3" *ngIf="isManualValidation">
    {{
      message ||
        'El cashin se creó y quedó en validación manual. No hay link ni cuenta destino todavía.'
    }}
  </p>
  <p class="p-text-secondary mb-3" *ngIf="providerError">
    {{ providerError }}
  </p>
  <div class="form-item" *ngIf="transactionId">
    <label>Cashin</label>
    <input type="text" pInputText [value]="transactionId" readonly class="w-full" />
  </div>

  <ng-container *ngIf="instructions as info">
    <p class="p-text-secondary mb-3" *ngIf="!isManualValidation">
      {{
        isSpeiClabe
          ? 'Transfiere por SPEI el monto exacto a esta CLABE. Bitso rechaza importes distintos.'
          : 'Envía el PIX / transferencia a esta cuenta destino, desde la clave ya registrada, por el mismo monto.'
      }}
    </p>
    <div class="form-item" *ngIf="info.beneficiary">
      <label>Beneficiario</label>
      <input type="text" pInputText [value]="info.beneficiary" readonly class="w-full" />
    </div>
    <div class="form-item" *ngIf="info.bank">
      <label>Banco</label>
      <input type="text" pInputText [value]="info.bank" readonly class="w-full" />
    </div>
    <div class="form-item" *ngIf="destination">
      <label>{{ destinationLabel }}</label>
      <div class="link-box">
        <input
          type="text"
          pInputText
          [value]="destination"
          readonly
          class="link-input w-full"
        />
        <i
          class="pi pi-copy copy-icon"
          (click)="utilsService.copyToClipboard(destination)"
          pTooltip="Copiar"
        ></i>
      </div>
    </div>
    <div class="form-item" *ngIf="info.expiration_date">
      <label>Vence</label>
      <input
        type="text"
        pInputText
        [value]="info.expiration_date"
        readonly
        class="w-full"
      />
    </div>
    <div class="form-item" *ngIf="info.identity_number">
      <label>{{ info.identity_type || 'Documento' }}</label>
      <input
        type="text"
        pInputText
        [value]="info.identity_number"
        readonly
        class="w-full"
      />
    </div>
    <div class="form-item" *ngIf="info.email">
      <label>Email</label>
      <input type="text" pInputText [value]="info.email" readonly class="w-full" />
    </div>
  </ng-container>
</div>
